import React from "react";
import {Doughnut , Line , Bar} from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, PointElement, LineElement,  Legend, Tooltip} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ReactECharts from "echarts-for-react";

// Register chart components
ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend, ChartDataLabels);


// Global chart font configuration
ChartJS.defaults.font.family = 'Josefin Sans, sans-serif';
ChartJS.defaults.plugins.datalabels = {
  color: '#333',
  font: {
    size: 12,
    weight: 'bold',
  },
};


//Target Market Doughnut Chart Fnction
export const TargetMarketChart = () => {
    const targetMarketData =  {
        labels: ['Target', 'Non-Target'],
        datasets: [
            {
                label : 'Market Target',
                data: [5, 95],
                backgroundColor: ['#e5004f', '#f7f7f7'],
                hoverOffset: 30,
                hoverBackgroundColor: ['#e5004f', '#e0e0e0'],
            },
        ],
    };

    const targetMarketOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Hide the legend for simplicity
            },
            tooltip: {
                callbacks: {
                    label: (context) => `Target: ${context.raw}%`, // Tooltip shows the target value
                },
            },
            datalabels: {
                display: (context) => context.dataIndex === 0, // Show value only for the "Target" slice
                formatter: (value) => `${value}%`,
                color: '#000000', // Set datalabel font color to black
                font: {
                    size: 16,
                    weight: 'bold',
                },
                anchor: 'center',
                align: 'center',
            },
        },
    };
    

    return <Doughnut data={targetMarketData} options={targetMarketOptions}/>
};

//Retail Market Growth Chart
export const RetailMarketGrowthChart = () => {
    const retailMarketGrowthData = {
        labels: ['2020', '2025'],
        datasets: [
            {
                label: 'Retail Market Growth ($B)',
                data: [883, 1300],
                borderColor: '#36A2EB',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: true,
            },
        ],
    };

    const retailMarketGrowthOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                formatter: (value) => `$${value}B`,
                color: '#333',
                font: {
                    size: 12,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            x: {
                offset: true,
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return <Line data={retailMarketGrowthData} options={retailMarketGrowthOptions}/>
};

//eCommerce Growth Chart
export const ECommerceGrowthChart = () => {
    const eCommerceGrowthData = {
        labels: ['2020', '2024'],
        datasets: [
            {
                label: 'eCommerce Growth (CAGR 27%)',
                data: [50, 111],
                backgroundColor: ['#FFCE56', '#FF6384'],
                borderColor: ['#FFCE56', '#FF6384'],
                borderWidth: 1,
            },
        ],
    };

    const eCommerceGrowthChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                formatter: (value) => `$${value}B`,
                color: '#333',
                font: {
                    size: 12,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return < Bar data={eCommerceGrowthData} options={eCommerceGrowthChartOptions}/>
};

//Target Unorganized Retailers  Doughnut Chart Fnction
export const TargetRetailersChart = () => {
    const targetRetailersData =  {
        labels: ['Unorganized Retailers', 'Organized Retailers'],
        datasets: [
            {
                label : 'Market Target',
                data: [88, 12],
                backgroundColor: ['#e5004f', '#f7f7f7'],
                hoverOffset: 30,
                hoverBackgroundColor: ['#e5004f', '#e0e0e0'],
            },
        ],
    };

    const targetRetailersOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Hide the legend for simplicity
            },
            tooltip: {
                callbacks: {
                    label: (context) => `Target: ${context.raw}%`, // Tooltip shows the target value
                },
            },
            datalabels: {
                display: (context) => context.dataIndex === 0, // Show value only for the "Target" slice
                formatter: (value) => `${value}%`,
                color: '#000000', // Set datalabel font color to black
                font: {
                    size: 16,
                    weight: 'bold',
                },
                anchor: 'center',
                align: 'center',
            },
        },
    };
    

    return <Doughnut data={targetRetailersData} options={targetRetailersOptions}/>
};

//Sales Team Expansion Chart
export const SalesTeamExpansionChart = () => {
    const salesTeamExpansionData = {
        labels: ['Year-1', 'Year-2', 'Year-3', 'Year-4', 'Year-5'],
        datasets: [
            {
                label: 'Sales Team',
                data: [100, 220, 340, 460, 580],
                borderColor: '#36A2EB',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: true,
            },
        ],
    };

    const salesTeamExpansionOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                formatter: (value) => `${value}`,
                color: '#333',
                font: {
                    size: 12,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            x: {
                offset: true,
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return <Line data={salesTeamExpansionData} options={salesTeamExpansionOptions}/>
};


// Use of Funds Chart
/*export const BudgetChart = () => {
    const budgetChartOptions = {
        chart: {
            type: "pie",
            backgroundColor: "transparent",
            options3d: {
                enabled: true,
                alpha: 45, //Tilt angle
                beta: 0, // Rotate horizontally
                depth: 35, // Enhance 3D depth
            },
        },
        title: {
            text: null, //Omitted the chart title
            align: "center",
            style: {
                fontSize: "16px",
                color: "#E5004F",
                fontFamily: "Josefin Sans, sans-serif",
            },
            tooltip: {
                pointFormat: "<b>{oint.percentage:.1f}%</b>",
                style: {
                    fontFamily: 'Josefin Sans', 
                    fontSize: '14px',
                },
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                innerSize: 0, // No inner radius as its not a donut chart
                depth: 35, // Adjust depth for 3D effect
                edgeWidth: 5, // For a more pronounced 3D effect
                borderColor: '#fff', //  border to give a rounded illusion
                borderWidth: 10, // Slight border width for smoothing
                dataLabels: {
                    enabled: true,
                    //format: "{point.name}: {point.percentage:.1f} %",
                    formatter: function () {
                        return `${this.point.name}: <b>${this.y}%</b>`; // Label format
                    },
                    style: {
                        fontFamily: 'Josefin Sans',
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#333",
                    },
                },
                edgeWidth: 2, // Optional: Emphasize the 3D effect with edge width
                borderRadius: 10, // Rounded edges for the pie slices
            },
        },
        series: [
            {
                name: "Percentage",
                data: [
                    { name: "Product Development", y: 40, color: "#E5004F" },
                    { name: "Marketing and User Acquisition", y: 30, color: "#A0A0A0" },
                    { name: "Operational Costs", y: 20, color: "#5C5C5C" },
                    { name: "Sales Team Expansion", y: 10, color: "#333333" },
                ],
            },
        ],
        credits: {
            enabled: false, // Remove Highcharts branding
        },
        legend: {
            enabled: false, // Optional: Disable the legend
        },
    };

    return (
        <div style={{ width: "100%",  margin: "0 auto" }}>
          <HighchartsReact highcharts={Highcharts} options={budgetChartOptions} />
        </div>
      );
};*/
    
export const BudgetChart = () => {
    const budgetChartOptions = {
      tooltip: {
        fontFamily: "Josefin Sans",
        trigger: "item",
        formatter: "{b}: {c}% ", // Tooltip format
      },
      series: [
        {
          name: "Use Of Funds",
          type: "pie",
          radius: ["40%", "70%"], // Inner and outer radius
          roseType: "radius", // Optional: Rose chart effect
          itemStyle: {
            borderRadius: 10, // Rounded edges
            borderColor: "#fff",
            borderWidth: 2, // White border for contrast
          },
          label: {
            formatter: "{b}: {c}%", // Label format
            color: "#333",
            fontSize: 14,
            fontWeight: "bold",
            fontFamily: "Josefin Sans", // Apply Josefin Sans font
          },
          data: [
            { value: 40, name: "Product Development", itemStyle: { color: "#E5004F" } },
            { value: 30, name: "Marketing and User Acquisition", itemStyle: { color: "#A0A0A0" } },
            { value: 20, name: "Operational Costs", itemStyle: { color: "#5C5C5C" } },
            { value: 10, name: "Sales Team Expansion", itemStyle: { color: "#333333" } },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  
    return (
      <div style={{ width: "100%", margin: "0 auto" }}>
        <ReactECharts option={budgetChartOptions} style={{ height: "400px" }} />
      </div>
    );
  };

//Estimated Loss Chart
export const EstimatedLossChart = () => {
    const estimatedLossData = {
        labels: ['Current', 'Future'],
        datasets: [
            {
                label: 'Loss in Percent (%)',
                data: [-40, -60],
                borderColor: '#36A2EB',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: true,
            },
        ],
    };

    const estimatedLossOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                formatter: (value) => `${value}%`,
                color: '#333',
                font: {
                    size: 12,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            x: {
                offset: true,
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return <Line data={estimatedLossData} options={estimatedLossOptions}/>
};

//Financial Projections table and chart
export const FinancialProjections = () => {
    const financialProjectionsTable = [
        [" Year ", "Sales Force", "Merchant Acquisitions", "No. Of Online Sales (in Cr)", "Revenue (in Cr)", "Expenses(in Cr)", "Profit / Loss (in Cr)"],
        ["Year-1", 100, 11200, 0.35, 7.28, 7.37, -0.09],
        ["Year-2", 220, 39600, 3.24, 67.35, 43.90, 23.45],
        ["Year-3", 340, 68400, 9.57, 199.22, 101.14, 98.08],
        ["Year-4", 460, 97200, 19.36, 403.01, 185.75, 217.26],
        ["Year-5", 580, 126000, 32.61, 678.74, 330.46, 348.28],
    ];
  
    const years = financialProjectionsTable.slice(1).map(row => row[0]); // Extract years
    // Select Metrics 4, 5, and 6
    const selectedMetricIndices = [4, 5, 6]; // Columns for Metrics 4, 5, and 6
    const metrics = selectedMetricIndices.map(index => financialProjectionsTable[0][index]); // Metric names
    const financialProjectionsData = financialProjectionsTable
        .slice(1) // Skip the header row
        .map(row => selectedMetricIndices.map(index => row[index])); // Extract selected metrics

    const financialProjectionsChartData = {
      labels: years,
      datasets: metrics.map((metric, index) => ({
        label: metric,
        data: financialProjectionsData.map(row => row[index]),
        borderColor: `hsl(${(index * 60) % 360}, 70%, 50%)`,
        backgroundColor: `hsl(${(index * 60) % 360}, 70%, 70%)`,
        tension: 0.3, // Smooth curve
        fill: false,
      })),
    };
  
    const financialProjectionsChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: "bottom", // Move legend to the bottom
        },
        tooltip: {
          enabled: true,
        },
      },
      scales: {
        x: {
          /*title: {
            display: true,
            text: "Year",
          },*/
        },
        y: {
          beginAtZero: true,
          /*title: {
            display: true,
            text: "Values",
          },*/
        },
      },
    };
  
    return (
        
        
        <div className="financial-projections-container">
          {/* Table Container */}
          <div className="financial-projections-table-container">
            <h3 className="chart-heading">Financial Projections Table</h3>
            <div className="table-wrapper">
              <table className="financial-projections-table">
                <thead>
                  <tr>
                    {financialProjectionsTable[0].map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {financialProjectionsTable.slice(1).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
      
          {/* Chart Container */}
          <div className="financial-projections-chart-container">
            <h3 className="chart-heading">Financial Projections Chart</h3>
            <div className="table-wrapper">
              <Line data={financialProjectionsChartData} options={financialProjectionsChartOptions} />
            </div>
          </div>
        </div>
      
      
    );
  };
  